import React, { Suspense } from "react";
import { Link } from "react-router-dom";

export default function EditOption() {
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  let editlink = "";
  if (userdata) {
    editlink = (
      <Link
        to="/edit-column"
        target="_blank"
        className="btn btn-danger"
        title="Edit Column"
      >
        <i className="fa fa-star"></i>
      </Link>
    );
  }
  return <Suspense fallback={<div>....</div>}>{editlink}</Suspense>;
}
